
import { Link } from 'react-router-dom';

const ContatosPage = () => {
  return (
    <div className="min-h-screen bg-black overflow-x-hidden" style={{ fontFamily: 'Manrope, sans-serif' }}>
      {/* Floating Navigation */}
      <nav className="fixed top-6 left-1/2 transform -translate-x-1/2 z-50 bg-black/80 backdrop-blur-xl border border-yellow-500/30 rounded-full px-8 py-4 transition-all duration-500">
        <div className="flex items-center space-x-8">
          <div className="text-xl font-bold text-yellow-400" style={{ fontFamily: 'Cinzel Decorative, serif' }}>
            DLUXMEN
          </div>
          <div className="hidden lg:flex items-center space-x-6">
            <Link
              to="/"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-home-line"></i>
              <span>Início</span>
            </Link>
            <Link
              to="/apresentacao"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-play-circle-line"></i>
              <span>Experience</span>
            </Link>
            <Link
              to="/equipe"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-team-line"></i>
              <span>Team</span>
            </Link>
            <Link
              to="/produtos"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-fire-line"></i>
              <span>Produtos</span>
            </Link>
            <Link
              to="/contatos"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-black bg-yellow-400"
            >
              <i className="ri-phone-line"></i>
              <span>Contact</span>
            </Link>
          </div>
          <button
            onClick={() => window.open('https://wa.me/5511914840141?text=Olá!%20Quero%20conhecer%20os%20produtos%20DLUXMEN', '_blank')}
            className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white px-6 py-2 rounded-full text-sm font-semibold transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer shadow-lg shadow-green-500/25"
          >
            <i className="ri-whatsapp-line"></i>
            <span>WhatsApp</span>
          </button>
        </div>
      </nav>

      {/* Atendimento */}
      <section className="py-32 bg-gradient-to-b from-black via-emerald-950 to-black relative min-h-screen">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <div className="inline-flex items-center bg-yellow-400/10 border border-yellow-400/30 rounded-full px-6 py-2 mb-8">
              <i className="ri-customer-service-line text-yellow-400 mr-2"></i>
              <span className="text-yellow-400 text-sm font-medium">ATENDIMENTO</span>
            </div>
            
            <h2 className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-300 mb-6" 
                style={{ fontFamily: 'Playfair Display, serif' }}>
              Atendimento Premium
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Experiência personalizada com especialistas em luxo
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
            {[
              {
                icon: 'ri-truck-line',
                title: 'Envio Rápido',
                description: 'Entrega expressa em todo Brasil com rastreamento completo'
              },
              {
                icon: 'ri-video-line',
                title: 'Vídeos HD',
                description: 'Veja cada peça em alta definição antes de decidir'
              },
              {
                icon: 'ri-phone-line',
                title: 'Separação por Vídeo',
                description: 'Escolha seu estilo em tempo real via chamada'
              },
              {
                icon: 'ri-customer-service-line',
                title: 'Atendimento VIP',
                description: 'Suporte personalizado com especialistas em luxo'
              }
            ].map((service, index) => (
              <div key={index} className="text-center group">
                <div className="w-20 h-20 bg-gradient-to-br from-yellow-600 to-yellow-500 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${service.icon} text-3xl text-black`}></i>
                </div>
                <h3 className="text-xl font-bold text-yellow-400 mb-3">{service.title}</h3>
                <p className="text-gray-300">{service.description}</p>
              </div>
            ))}
          </div>

          {/* Contact Methods */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              {
                icon: 'ri-whatsapp-line',
                title: 'WhatsApp',
                description: 'Atendimento direto com nossos especialistas',
                action: () => window.open('https://wa.me/5511914840141?text=Olá!%20Quero%20conhecer%20os%20produtos%20DLUXMEN', '_blank'),
                buttonText: 'Enviar Mensagem'
              },
              {
                icon: 'ri-mail-line',
                title: 'E-mail',
                description: 'contato@dluxmen.com',
                action: () => window.location.href = 'mailto:contato@dluxmen.com',
                buttonText: 'Enviar E-mail'
              },
              {
                icon: 'ri-instagram-line',
                title: 'Instagram',
                description: '@dluxmen.brasil',
                action: () => window.open('https://instagram.com/dluxmen.brasil', '_blank'),
                buttonText: 'Ver Perfil'
              }
            ].map((contact, index) => (
              <div key={index} className="bg-gradient-to-br from-yellow-600/10 to-yellow-500/5 border border-yellow-500/20 rounded-2xl p-8 text-center hover:scale-105 transition-all duration-300">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-600 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${contact.icon} text-2xl text-black`}></i>
                </div>
                <h3 className="text-xl font-bold text-yellow-400 mb-3">{contact.title}</h3>
                <p className="text-gray-300 mb-6">{contact.description}</p>
                <button 
                  onClick={contact.action}
                  className="w-full bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-700 hover:to-yellow-600 text-black font-semibold py-3 px-6 rounded-full transition-all duration-300"
                >
                  {contact.buttonText}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center bg-yellow-400/10 border border-yellow-400/30 rounded-full px-6 py-2 mb-8">
              <i className="ri-map-pin-line text-yellow-400 mr-2"></i>
              <span className="text-yellow-400 text-sm font-medium">LOCALIZAÇÃO</span>
            </div>
            
            <h2 className="text-4xl font-bold text-yellow-400 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Nossa Loja
            </h2>
            <p className="text-gray-300 max-w-2xl mx-auto">
              Conheça nosso espaço exclusivo em São Paulo, dedicado ao universo do luxo masculino
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto bg-gradient-to-br from-yellow-600/10 to-yellow-500/5 border border-yellow-500/20 rounded-2xl overflow-hidden">
            <div className="p-8 text-center">
              <h3 className="text-2xl font-bold text-yellow-400 mb-4">DLUXMEN Flagship Store</h3>
              <p className="text-gray-300 mb-2">Rua Oscar Freire, 2424 - Jardim Paulista</p>
              <p className="text-gray-300 mb-2">São Paulo - SP, 01426-001</p>
              <p className="text-gray-300 mb-6">Brasil</p>
              
              <div className="flex flex-wrap justify-center gap-4">
                <button 
                  onClick={() => window.open('https://maps.google.com/?q=Rua Oscar Freire, 2424 - Jardim Paulista, São Paulo - SP', '_blank')}
                  className="bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-700 hover:to-yellow-600 text-black font-semibold py-3 px-6 rounded-full transition-all duration-300 flex items-center space-x-2"
                >
                  <i className="ri-map-pin-line"></i>
                  <span>Ver no Mapa</span>
                </button>
                
                <button 
                  onClick={() => window.open('https://wa.me/5511914840141', '_blank')}
                  className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white font-semibold py-3 px-6 rounded-full transition-all duration-300 flex items-center space-x-2"
                >
                  <i className="ri-whatsapp-line"></i>
                  <span>Agendar Visita</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContatosPage;
